import React, { useEffect, useReducer, useState } from 'react';
import Notification from '../Common/Notification';
import CallOut from '../Common/CallOut';
import ActivityLoader from '../Common/ActivityLoader';
import { useStudent } from '../../DataStore/StudentContext';
import ajaxStudent from '../../util/remote/ajaxStudent';
import Cropper from 'react-easy-crop';
import getCroppedImg from '../../util/cropImage';

const reducer = (state, action) => {
  if (action.type === 'RESET') {
    return { ...initialState };
  }
  return { ...state, [action.type]: action.value };
};

const initialState = {
  actualFile: null,
  fileSource: '',
  loading: false,
  crop: { x: 0, y: 0 },
  zoom: 1,
  croppedAreaPixels: null,
  showCropper: false,
};

const ChangeStudentPhoto = ({ studentId }) => {
  const [currentNotify, setNotify] = useState(null);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { loadProfile } = useStudent();

  useEffect(() => {
    if (currentNotify) {
      setTimeout(() => {
        setNotify(null);
      }, 5000);
    }
  }, [currentNotify]);

  const handleCropComplete = (_, croppedAreaPixels) => {
    dispatch({ type: 'croppedAreaPixels', value: croppedAreaPixels });
  };

  const handleSave = async (event) => {
    event.preventDefault();
    if (state.loading) return;

    if (!state.actualFile) {
      setNotify(
        <Notification type="danger" message="Please select a photo before uploading." />
      );
      return;
    }
    

    dispatch({ type: 'loading', value: true });
    try {
      const croppedImage = await getCroppedImg(state.actualFile, state.croppedAreaPixels);

      const server_response = await ajaxStudent.updateStudentPhoto({
        student_id: studentId,
        photo: {file: croppedImage},
      });

      dispatch({ type: 'loading', value: false });

      if (server_response.status === 'OK') {
        setNotify(
          <Notification type="success" message={server_response.message} />
        );
        loadProfile(studentId);
        dispatch({ type: 'RESET' });
      } else {
        setNotify(
          <Notification type="danger" message={server_response.message} />
        );
      }
    } catch (error) {
      dispatch({ type: 'loading', value: false });
      setNotify(
        <Notification type="danger" message="Failed to crop and upload the image." />
      );
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file || !file.type.startsWith('image/') || file.size > 5 * 1024 * 1024) {
      setNotify(
        <Notification type="danger" message="Only image files under 5MB are allowed." />
      );
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      dispatch({ type: 'actualFile', value: e.target.result });
      dispatch({ type: 'showCropper', value: true });
    };
  };

  return (
    <div className="card-body">
      <CallOut
        title="Student Photo"
        description="This photo will be used as the student report photo. You can upload a new photo or document related to the student using the student files section."
      />
      {currentNotify}

      <form className="form-horizontal" method="post" onSubmit={handleSave}>
        <div className="form-group">
          <label className="font-weight-bold d-block mb-2">Select Student Photo</label>
          <div className="custom-file">
            <input
              type="file"
              accept="image/*"
              className="custom-file-input"
              id="studentPhotoInput"
              onChange={handleFileChange}
            />
            <label className="custom-file-label" htmlFor="studentPhotoInput">
              Choose photo
            </label>
          </div>
        </div>

        {state.showCropper && state.actualFile && (
          <div style={{ position: 'relative', width: '100%', height: 350, marginTop: 20 }}>
            <Cropper
              image={state.actualFile}
              crop={state.crop}
              zoom={state.zoom}
              aspect={1}
              cropShape="round"
              showGrid={false}
              onCropChange={(value) => dispatch({ type: 'crop', value })}
              onZoomChange={(value) => dispatch({ type: 'zoom', value })}
              onCropComplete={handleCropComplete}
            />
          </div>
        )}

        {state.showCropper && (
          <div className="mt-3">
            <label className="d-block mb-1">Zoom</label>
            <input
              type="range"
              min={1}
              max={3}
              step={0.1}
              value={state.zoom}
              onChange={(e) => dispatch({ type: 'zoom', value: Number(e.target.value) })}
              className="custom-range"
              style={{ width: '100%' }}
            />
          </div>
        )}

        <div className="text-right mt-3">
          {!state.loading && (
            <button type="submit" className="btn btn-lg btn-success">
              Upload Photo
            </button>
          )}
          {state.loading && <ActivityLoader />}
        </div>
      </form>
    </div>
  );
};

export default ChangeStudentPhoto;
